/**
 *
 * Download blob data,
 *
 * Create anchor element and programmatically click on it
 *
 * @param {string} filename - The filename to give the download
 * @param {Blob} blob
 *
 */
function createClickDownload(filename, blob) {
    const a = document.createElement('a');

    const objectURL = window.URL.createObjectURL(blob);

    a.setAttribute('href', objectURL);
    a.setAttribute('download', filename);

    a.click();

    URL.revokeObjectURL(objectURL);
}

export { createClickDownload };
